import React, { useEffect } from 'react'
import Navbar from '../common/Navbar'
import Footer from '../common/Footer'
import { useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import BlogList from '../components/blogs/BlogList'

const Blogs = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>        <Helmet>
    <meta name="keywords" content="best digital marketing agencies,digital marketing strategy,digital marketing services,digital marketing website,digital marketing ads,about digital marketing,whatsapp digital marketing,digital marketing and social media marketing,all about digital marketing,marketing digital marketing,best digital marketing strategies,digital marketing support,top digital marketing agencies in the world"/> 
    <title>About Us | Trusted Digital Marketing & SMS Service Provider</title>
        <meta
          name="description"
          content="We help brands connect, engage, and convert customers using powerful digital marketing, SMS, and WhatsApp communication solutions."
        />
  </Helmet>
  <div>
        <Navbar/>
        <BlogList/>
        <Footer />
    </div></>

  )
}

export default Blogs